import axios from 'axios'

export default {
    getHceTxContact(authenticationId) {
        return axios.post(`${process.env.VUE_APP_API_BASE_URL}/` + "getufncontact", '{"authenticationId":' + '"' + authenticationId + '"}')
            .then((res) => {
                return Promise.resolve(res.data)
            })
            .catch(e => {
                console.log(e);
            });
    },
    checkHceTxContact(userName) {
        console.log('userName=' + userName);
        return axios.post(`${process.env.VUE_APP_API_BASE_URL}/` + "checkufncontact", '{"authenticationId":' + '"' + userName + '"}')
            .then((res) => {
                return Promise.resolve(res.data)
            })
            .catch(e => {
                console.log(e);
            });
    },
    insertHceTxContact(email, firstName, lastName, organizationName, address1, address2, city, stateProvince, zip, phone, userName) {
        return axios.post(`${process.env.VUE_APP_API_BASE_URL}/` + "insertufncontact", '{"email":' + '"' + email + '","firstName":' + '"' + firstName + '","lastName":' + '"' + lastName + '","organizationName":' + '"' + organizationName + '","address1":' + '"' + address1 + '","address2":' + '"' + address2 + '","city":' + '"' + city + '","stateProvince":' + '"' + stateProvince + '","zip":' + '"' + zip + '","phone":' + '"' + phone + '","authenticationId":' + '"' + userName + '"}')
            .then((res) => {
                return Promise.resolve(res.data)
            })
            .catch(e => {
                console.log(e);
            });
    },
    updateHceTxContact(contactId, email, firstName, lastName, organizationName, address1, address2, city, state, zip, phone) {
        return axios.post(`${process.env.VUE_APP_API_BASE_URL}/` + "updateufncontact", '{"contactId":' + '"' + contactId + '","email":' + '"' + email + '","firstName":' + '"' + firstName + '","lastName":' + '"' + lastName + '","organizationName":' + '"' + organizationName + '","address1":' + '"' + address1 + '","address2":' + '"' + address2 + '","city":' + '"' + city + '","stateProvince":' + '"' + state + '","zip":' + '"' + zip + '","phone":' + '"' + phone + '"}')
            .then((res) => {
                return Promise.resolve(res.data)
            })
            .catch(e => {
                console.log(e);
            });
    }, getHceTxTransactionContactSummary(contactId) {
        return axios.post(`${process.env.VUE_APP_API_BASE_URL}/` + "getufntransactionsummary", '{"contactId":' + '"' + contactId + '"}')
            .then((res) => {
                return Promise.resolve(res.data)
            })
            .catch(e => {
                console.log(e);
            });
    },
    insertHceTransaction(transactionName, transactionDescription, transactionType, anticipatedDate, propsedCompletionDate, contactId) {
        return axios.post(`${process.env.VUE_APP_API_BASE_URL}/` + "saveufntransaction", '{"transactionName":' + '"' + transactionName + '","transactionDescription":' + '"' + transactionDescription + '","transactionType":' + '"' + transactionType + '","anticipatedDate":' + '"' + anticipatedDate + '","propsedCompletionDate":' + '"' + propsedCompletionDate + '","contactId":' + '"' + contactId + '"}')
            .then((res) => {
                return Promise.resolve(res.data)
            })
            .catch(e => {
                console.log(e);
            });
    },
    updateHceTransaction(transactionId, transactionName, transactionDescription, transactionType, anticipatedDate, propsedCompletionDate, contactId) {
        return axios.post(`${process.env.VUE_APP_API_BASE_URL}/` + "updateufntransaction", '{"transactionId":' + '"' + transactionId + '","transactionName":' + '"' + transactionName + '","transactionDescription":' + '"' + transactionDescription + '","transactionType":' + '"' + transactionType + '","anticipatedDate":' + '"' + anticipatedDate + '","propsedCompletionDate":' + '"' + propsedCompletionDate + '","contactId":' + '"' + contactId + '"}')
            .then((res) => {
                return Promise.resolve(res.data)
            })
            .catch(e => {
                console.log(e);
            });
    },
    getHceTransactionTypes() {
        return axios.get(`${process.env.VUE_APP_API_BASE_URL}/` + "getufntransactiontypepicklist/Transaction1Type")
            .then((res) => {
                return Promise.resolve(res.data)
            })
            .catch(e => {
                console.log(e);
            });
    },
    getHceTransactionDocumentTypes() {
        return axios.get(`${process.env.VUE_APP_API_BASE_URL}/` + "getufntransactiontypepicklist/Document1Type")
            .then((res) => {
                return Promise.resolve(res.data)
            })
            .catch(e => {
                console.log(e);
            });
    },
    uploadHceTransactionDocuments(transactionId, contactId, documentTypeId, base64string, fileName, fileContentType) {
        const payLoad = {
            fileBase64ByteStream: base64string,
            fileName: fileName,
            contentType: fileContentType,
            transactionId: transactionId,
            contactId: contactId,
            documentTypeId: documentTypeId
        }
        console.log(JSON.stringify("transactionId="+transactionId+"::contactId="+contactId+"::documentTypeId="+documentTypeId+"::fileName="+fileName));
        return axios.post(`${process.env.VUE_APP_API_BASE_URL}/` + 'transaction/document/upload', payLoad).then((res) => {
            return Promise.resolve(res.data)
        })
            .catch(e => {
                console.log(e);
            });
    },
    getHceTransactionAndDocuments(transactionId, contactId) {
        return axios.post(`${process.env.VUE_APP_API_BASE_URL}/` + 'getufntransactionanddocuments/' + transactionId + '/' + contactId).then((res) => {
            return Promise.resolve(res.data)
        })
            .catch(e => {
                console.log(e);
            });
    }, deleteHceTransactionDocuments(txDocuments) {
        return axios.post(`${process.env.VUE_APP_API_BASE_URL}/` + 'transaction/document/delete', '{"transactionDocuments":' + txDocuments + '}').then((res) => {
            return Promise.resolve(res.data)
        })
            .catch(e => {
                console.log(e);
            });
    },
}
